import React, { FC } from "react";
import { useTheme } from "@material-ui/core";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const EmployeesIcon: FC<SvgIconProps> = props => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary.main;

  return (
    <SvgIcon {...props} width="54" height="54" viewBox="0 0 54 54">
      <g fill="none" fillRule="evenodd">
        <path
          stroke={primary}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4.466 17C2.551 17 1 18.254 1 19.8v29.4C1 50.746 2.551 52 4.466 52h45.068C51.449 52 53 50.746 53 49.2V19.8c0-2.8-3.466-2.8-3.466-2.8H24.45"
        />
        <g
          stroke={primary}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M0 .5L18 .5M4 5.5L15 5.5" transform="translate(31 21)" />
        </g>
        <g
          stroke={secondary}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path
            d="M2.5 6C1.12 6 0 5.104 0 4s1.12-2 2.5-2S5 2.896 5 4M2.5 6C3.88 6 5 6.896 5 8s-1.12 2-2.5 2S0 9.104 0 8M2.5 2L2.5 0M2.5 12L2.5 10"
            transform="translate(37 33)"
          />
        </g>
        <path
          fill={primary}
          d="M19.899 35H14.1C10.731 35 8 37.669 8 40.96v2.93c.572.451 1.179.867 1.827 1.233 4.438 2.503 9.908 2.503 14.346 0 .648-.366 1.255-.782 1.827-1.232v-2.785C26 37.669 23.268 35 19.899 35M23 28c0 3.314-2.686 6-6 6s-6-2.686-6-6 2.686-6 6-6 6 2.686 6 6"
        />
        <g
          stroke={primary}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M0 3L3 0 6 3M3 0L3 13.6" transform="translate(6 1)" />
        </g>
        <g
          stroke={primary}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M0 3L3 0 6 3M3 0L3 13.6" transform="matrix(1 0 0 -1 15 15)" />
        </g>
      </g>
    </SvgIcon>
  );
};

export default EmployeesIcon;
